<template>
    <div class="rounded px-2 py-[2px] bg-[#E5F2EA] text-won-green flex items-center w-min">
        <span class="font-medium text-[12px] leading-[14.5px]">{{ text }}</span>
    </div>
</template>

<script>
import { toRefs } from "vue"

export default {
    props: {
        style: {
            type: String,
            default: "green",
        },
        text: {
            type: String,
            default: 'Completed',
        }
    },
    setup(props) {
        const labelStyles = {
            green: "rounded px-2 py-[2px] bg-[#E5F2EA] text-won-green"
        }

        const { text, style } = toRefs(props)

        return {
            text,
            styles: labelStyles[style]  
        };
    }
}
</script>